"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var styles_1 = require("../../common/styles");

var utilities_1 = require("../../utilities");

var GenericWidget_1 = tslib_1.__importDefault(require("./GenericWidget"));

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  margin: 1em 0 0 0;\n"], ["\n  ", ";\n  margin: 1em 0 0 0;\n"])), styles_1.general);
var MaxWidth = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 0 ", "px;\n  max-width: ", "px;\n"], ["\n  margin: 0 auto;\n  padding: 0 ", "px;\n  max-width: ", "px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.padding;
}, function (_a) {
  var theme = _a.theme;
  return theme.app.maxWidth || 1200;
});

var Widgets =
/** @class */
function (_super) {
  tslib_1.__extends(Widgets, _super);

  function Widgets(props) {
    var _this = _super.call(this, props) || this;

    _this.renderWidgets = _this.renderWidgets.bind(_this);
    return _this;
  }

  Widgets.prototype.componentDidCatch = function (e) {
    console.error('Uncaught error in csm-widgets!', e);
  };

  Widgets.prototype.renderWidgets = function (items) {
    var _a = this.props,
        override = _a.override,
        renderEmpty = _a.renderEmpty,
        renderLink = _a.renderLink;
    return utilities_1.transformDeprecatedContent(items).map(function (widget, idx) {
      var key = "widget_" + widget.type + "_" + idx;

      if (widget.type in override) {
        return react_1["default"].createElement(react_1["default"].Fragment, {
          key: key
        }, override[widget.type](widget));
      }

      return react_1["default"].createElement(GenericWidget_1["default"], {
        key: key,
        widget: widget,
        renderLink: renderLink,
        renderEmpty: renderEmpty,
        override: override
      });
    });
  };

  Widgets.prototype.render = function () {
    var _a = this.props,
        items = _a.items,
        _b = _a.className,
        className = _b === void 0 ? '' : _b;
    return react_1["default"].createElement(Wrapper, {
      className: className + " content-widgets"
    }, react_1["default"].createElement(MaxWidth, null, this.renderWidgets(items)));
  };

  return Widgets;
}(react_1.PureComponent);

Widgets.propTypes = {
  override: prop_types_1["default"].objectOf(prop_types_1["default"].func),
  items: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
    type: prop_types_1["default"].string.isRequired
  })),
  renderLink: prop_types_1["default"].func,
  renderEmpty: prop_types_1["default"].func,
  className: prop_types_1["default"].string
};
Widgets.defaultProps = {
  items: [],
  override: {},
  renderLink: undefined,
  renderEmpty: undefined,
  className: undefined
};
exports["default"] = Widgets;
var templateObject_1, templateObject_2;